import React from 'react';
import moment from 'moment';

class MonthItem extends React.Component {
  static defaultProps = {
    fromMonth: '',
    toMonth: '',
  };

  selectMonth = (t) => {
    if (this.props.isToDate && this.props.toMonth !== this.props.monthId) {
      this.props.selectMonth(t);
    } else if (this.props.isFromDate) {
      this.props.selectMonth(t);
    } else if (
      this.props.monthlyRevenueReport.start_date.split('T')[0] ===
      moment(this.props.lastMonthlyDatesSelected.fromDate)
        .toISOString()
        .split('T')[0]
    ) {
      this.props.onSelectSameMonth();
    } else {
      this.props.selectMonth(t);
    }
  };

  render() {
    let checked;
    if (this.props.isFromDate) {
      checked = this.props.fromMonth === this.props.monthId;
    } else if (this.props.isToDate) {
      checked = this.props.toMonth === this.props.monthId;
    }
    const className = !checked ? 'the-month-shape' : 'the-month-shape selected';
    return (
      <div className={className} onClick={() => this.selectMonth(this.props.monthId)} role="button" tabIndex={-1}>
        <div className="item-option">
          <div>{this.props.monthName}</div>
        </div>
      </div>
    );
  }
}

export default MonthItem;
